// Import aqua-ui theme types:
/// <reference types="../node_modules/@longline/aqua-ui/styled.d.ts" />

import * as React from 'react';
import styled from 'styled-components';
import { createRoot } from 'react-dom/client';

import { Main } from './Main';


const ANIMATION_OPACITY_STEP = 0.1; // 0.01

interface IConfig {
  /** URL to back-end API. Should end with a slash. */
  apiURL: string;
  /** Keycloak server base URL (no realm/path). */
  keycloakURL: string;
  /** Keycloak realm name. */
  keycloakRealm: string;
  /** Keycloak client ID for this app. */
  keycloakClient: string;
  /** URL to Organix API. */
  /** URL to Forge API. */
  forgeURL: string;
  /** Mapbox key. */
  mapboxKey: string;
}

class App {
  static config: IConfig;

  //
  // Fade out, then remove the loading screen.
  //  
  private static removeLoader = () => {
    const loader = document.getElementById("apploader");
    if(!loader) return;
    let opacity = parseFloat(getComputedStyle(loader).opacity);
    opacity = Math.max(opacity - ANIMATION_OPACITY_STEP, 0);
    loader.style.opacity = opacity.toString();
    if(opacity > 0) {
      requestAnimationFrame(App.removeLoader);
    } else {
      loader.remove();
    }
  }

  static run = async (node: React.ReactNode) => {
    const rootElement:any = document.getElementById('root');
    const root = createRoot(rootElement);

    // Try to download config.json:
    const res = await fetch("/config.json");
    // Remove loading screen.
    App.removeLoader();

    // Was download successful?
    if(!res.ok) {
      return root.render(
        <AppError error="Could not load config.json."/>
      );
    }

    // Try to parse config.json:
    try {
      App.config = await res.json() as IConfig;
    } catch {
      return root.render(
        <AppError error="Could not parse config.json."/>
      );      
    }

    // Render app:
    root.render(node);
  }
}

interface IProps {
  className?: string;
  error: string;
}

const AppError = styled((props: IProps) => {
  return (
    <div className={props.className}>
      <div className="box">
        <span className="title">Error:</span>
        <p className="text">{props.error}</p>
      </div>
    </div>
  )  
})`
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: crimson;
  color: white;
  font-family: sans-serif;
  .box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
  .title {
    font-weight: bold;
  }
`

App.run(<Main/>);

export { App }
